import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "page-mark-map"
};
const _hoisted_2 = {
  class: "inner custom-scroll"
};
const _hoisted_3 = {
  class: "mark-map-params"
};
const _hoisted_4 = {
  class: "param-line"
};
const _hoisted_5 = {
  class: "param-line"
};
const _hoisted_6 = {
  class: "text-info"
};
const _hoisted_7 = {
  class: "submit-btn flex-center"
};
const _hoisted_8 = {
  class: "param-line"
};
const _hoisted_9 = {
  class: "param-line flex-center"
};
const _hoisted_10 = {
  class: "chat-box"
};
const _hoisted_11 = {
  class: "body",
  id: "markmap"
};
const _hoisted_12 = {
  id: "toolbar"
};
import { nextTick, ref } from "vue";
import { Markmap } from "markmap-view";
import { Transformer } from "markmap-lib";
import { checkSession, getSystemInfo } from "@/store/cache";
import { httpGet, httpPost } from "@/utils/http";
import { ElMessage } from "element-plus";
import { Download } from "@element-plus/icons-vue";
import { Toolbar } from "markmap-toolbar";
import { useSharedStore } from "@/store/sharedata";
export default {
  __name: 'MarkMap',
  setup(__props) {
    const leftBoxHeight = ref(window.innerHeight - 105);
    //const rightBoxHeight = ref(window.innerHeight - 115);
    const rightBoxHeight = ref(window.innerHeight);
    const prompt = ref("");
    const text = ref("");
    const content = ref(text.value);
    const html = ref("");
    const isLogin = ref(false);
    const loginUser = ref({
      power: 0
    });
    const transformer = new Transformer();
    const store = useSharedStore();
    const loading = ref(false);
    const svgRef = ref(null);
    const markMap = ref(null);
    const models = ref([]);
    const modelID = ref(0);
    getSystemInfo().then(res => {
      text.value = res.data["mark_map_text"];
      content.value = text.value;
      initData();
      nextTick(() => {
        try {
          markMap.value = Markmap.create(svgRef.value);
          const {
            el
          } = Toolbar.create(markMap.value);
          document.getElementById("toolbar").append(el);
          update();
        } catch (e) {
          console.error(e);
        }
      });
    }).catch(e => {
      ElMessage.error("获取系统配置失败：" + e.message);
    });
    const initData = () => {
      httpGet("/model/list").then(res => {
        for (let v of res.data) {
          models.value.push(v);
        }
        modelID.value = models.value[0].id;
      }).catch(e => {
        ElMessage.error("获取模型失败：" + e.message);
      });
      checkSession().then(user => {
        loginUser.value = user;
        isLogin.value = true;
      }).catch(() => {});
    };
    const update = () => {
      try {
        const {
          root
        } = transformer.transform(processContent(text.value));
        markMap.value.setData(root);
        markMap.value.fit();
      } catch (e) {
        console.error(e);
      }
    };
    const processContent = text => {
      if (!text) {
        return text;
      }
      const arr = [];
      const lines = text.split("\n");
      for (let line of lines) {
        if (line.indexOf("```") !== -1) {
          continue;
        }
        line = line.replace(/([*_~`>])|(\d+\.)\s/g, "");
        arr.push(line);
      }
      return arr.join("\n");
    };
    window.onresize = () => {
      leftBoxHeight.value = window.innerHeight - 145;
      rightBoxHeight.value = window.innerHeight - 85;
    };
    const generate = () => {
      text.value = content.value;
      update();
    };

    // 使用 AI 智能生成
    const generateAI = () => {
      html.value = "";
      text.value = "";
      if (prompt.value === "") {
        return ElMessage.error("请输入你的需求");
      }
      if (!isLogin.value) {
        store.setShowLoginDialog(true);
        return;
      }
      loading.value = true;
      httpPost("/markMap/gen", {
        prompt: prompt.value,
        model_id: modelID.value
      }).then(res => {
        text.value = res.data;
        content.value = processContent(text.value);
        const model = getModelById(modelID.value);
        loginUser.value.power -= model.power;
        nextTick(() => update());
        loading.value = false;
      }).catch(e => {
        ElMessage.error("生成思维导图失败：" + e.message);
        loading.value = false;
      });
    };
    const getModelById = modelId => {
      for (let m of models.value) {
        if (m.id === modelId) {
          return m;
        }
      }
    };

    // download SVG to png file
    const downloadImage = () => {
      const svgElement = document.getElementById("markmap");
      // 将 SVG 渲染到图片对象
      const serializer = new XMLSerializer();
      const source = '<?xml version="1.0" standalone="no"?>\r\n' + serializer.serializeToString(svgRef.value);
      const image = new Image();
      image.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(source);

      // 将图片对象渲染
      const canvas = document.createElement("canvas");
      canvas.width = svgElement.offsetWidth;
      canvas.height = svgElement.offsetHeight;
      let context = canvas.getContext("2d");
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.fillStyle = "white";
      context.fillRect(0, 0, canvas.width, canvas.height);
      image.onload = function () {
        context.drawImage(image, 0, 0);
        const a = document.createElement("a");
        a.download = "LEHE-ai-xmind.png";
        a.href = canvas.toDataURL(`image/png`);
        a.click();
      };
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "mark-map-box",
        style: _normalizeStyle({
          height: leftBoxHeight.value + 'px'
        })
      }, [_cache[9] || (_cache[9] = _createElementVNode("h2", null, "思维导图创作中心", -1)), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_form, {
        "label-width": "80px",
        "label-position": "left"
      }, {
        default: _withCtx(() => [_cache[6] || (_cache[6] = _createElementVNode("div", {
          class: "param-line"
        }, "你的需求？", -1)), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input, {
          modelValue: prompt.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => prompt.value = $event),
          autosize: {
            minRows: 4,
            maxRows: 6
          },
          type: "textarea",
          placeholder: "请给AI输入提示词，让AI帮你完善"
        }, null, 8, ["modelValue"])]), _cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "param-line"
        }, "请选择生成思维导图的AI模型", -1)), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_select, {
          modelValue: modelID.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => modelID.value = $event),
          placeholder: "请选择模型",
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(models.value, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.name,
              value: item.id
            }, {
              default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.name), 1), _createVNode(_component_el_tag, {
                style: {
                  "margin-left": "5px",
                  "position": "relative",
                  "top": "-2px"
                },
                type: "info",
                size: "small"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.power) + "算力 ", 1)]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1032, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_text, {
          type: "primary"
        }, {
          default: _withCtx(() => [_cache[3] || (_cache[3] = _createTextVNode("当前可用算力：")), _createVNode(_component_el_text, {
            type: "warning"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(loginUser.value.power), 1)]),
            _: 1
          })]),
          _: 1
        })]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
          style: {
            "width": "200px"
          },
          type: "primary",
          dark: false,
          round: "",
          onClick: generateAI,
          loading: loading.value
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode(" 生成思维导图 ")])),
          _: 1
        }, 8, ["loading"])]), _cache[8] || (_cache[8] = _createElementVNode("div", {
          class: "param-line"
        }, "使用已有内容生成？", -1)), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_input, {
          modelValue: content.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => content.value = $event),
          autosize: {
            minRows: 4,
            maxRows: 6
          },
          type: "textarea",
          placeholder: "请用markdown语法输入您想要生成思维导图的内容！"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
          color: "rgb(78, 51, 254)",
          style: {
            "width": "200px"
          },
          dark: false,
          round: "",
          onClick: generate
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("直接生成（免费）")])),
          _: 1
        })])]),
        _: 1
      })])], 4), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [(_openBlock(), _createElementBlock("svg", {
        ref_key: "svgRef",
        ref: svgRef,
        style: _normalizeStyle({
          height: rightBoxHeight.value + 'px'
        })
      }, null, 4)), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_button, {
        onClick: downloadImage,
        type: "primary"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Download))]),
          _: 1
        }), _cache[10] || (_cache[10] = _createElementVNode("span", null, "下载图片", -1))]),
        _: 1
      })])])])])])]);
    };
  }
};